export const TURNSTILE_ENABLED = true;
export const CBU_SAME_BANK_ENABLED = false;
export const TIME_RESTRICTION_ENABLED = true;
